import React, { useState } from 'react';
import { Button, Card, FormLayout, TextField } from '@shopify/polaris';
import { useMutation } from '@apollo/react-hooks';
import { useTenantContext } from 'src/components/TenantProvider';
import NewCourseMutation from 'src/mutations/NewCourseMutation';
import BannerMessages from 'src/components/BannerMessages';
import ERROR_MESSAGSES from './constants';

const NewCourse = () => {
  const { session } = useTenantContext();
  const [createCourse, { data, error, loading }] =
    useMutation(NewCourseMutation);
  const [courseName, setCourseName] = useState('');
  const [isDisabled, setIsDisabled] = useState(false);
  const [showValidation, setShowValidation] = useState(false);
  const redirectToCourseBuilder = (location) => {
    window.open(location, '_top');
  };
  let errorMessages;
  let graphqlErrorMessage;

  if (error)
    graphqlErrorMessage = error.message.replace('GraphQL error:', '').trim();
  if (data) {
    const { location, result } = data.createCourse;
    if (result.success) {
      redirectToCourseBuilder(location);
    } else {
      errorMessages = result.errors.map(({ message }) => message).join('\n');
    }
  }

  return (
    <>
      {error && <BannerMessages message={graphqlErrorMessage} />}
      {data && !data.createCourse.result.success && (
        <BannerMessages message={errorMessages} />
      )}
      <Card>
        <Card.Section>
          <div>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                setShowValidation(true);
                if (courseName) {
                  setIsDisabled(true);
                  const variables = {
                    courseName,
                    sessionId: session.id,
                  };
                  createCourse({ variables });
                }
              }}
            >
              <FormLayout>
                <TextField
                  error={
                    showValidation &&
                    !courseName &&
                    ERROR_MESSAGSES.COURSE_NAME_REQUIRED
                  }
                  helpText="You can change this at any time"
                  label="Course name"
                  maxLength={255}
                  name="Course name"
                  placeholder="My Course"
                  type="text"
                  value={courseName}
                  onChange={(value) => setCourseName(value)}
                />
              </FormLayout>
              <div className="newcourse__btn-container">
                <Button disabled={isDisabled} loading={loading} primary submit>
                  Create
                </Button>
              </div>
            </form>
          </div>
        </Card.Section>
      </Card>

      <style jsx>{`
        .newcourse__btn-container {
          display: flex;
          justify-content: flex-end;
        }
      `}</style>
    </>
  );
};

export default NewCourse;
